import React from 'react'
import { Button } from '../../../components/button'

const Billing = () => {

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col px-0">
                        <h1 className="title">{gettext('Billing')}</h1>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Billing